// src/hooks/useResponsiveMenuLayout.js
import { useLayoutEffect, useRef, useState } from "react";
import { useDevice } from "./useDevice";

export function useResponsiveMenuLayout() {
  const {
    isMobile,
    width: viewportWidth,
    height: viewportHeight,
  } = useDevice();

  const containerRef = useRef(null);

  const [animReady, setAnimReady] = useState(false);

  // Base width (desktop) or base height (mobile)
  const [baseSize, setBaseSize] = useState(
    isMobile ? viewportHeight : viewportWidth
  );

  // menuWidth (desktop) or menuHeight (mobile)
  const [menuSize, setMenuSize] = useState(
    Math.round((isMobile ? viewportHeight : viewportWidth) * 0.3)
  );

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const measure = () => {
      if (isMobile) {
        const height =
          containerRef.current.getBoundingClientRect().height || viewportHeight;

        setBaseSize(height);
        setMenuSize(Math.round(height * 0.3)); // 30% bottom menu
      } else {
        const width =
          containerRef.current.getBoundingClientRect().width || viewportWidth;

        setBaseSize(width);
        setMenuSize(Math.round(width * 0.3)); // 30% sidebar
      }
    };

    measure();

    const ro = new ResizeObserver(measure);
    ro.observe(containerRef.current);

    const frame = requestAnimationFrame(() => setAnimReady(true));

    return () => {
      cancelAnimationFrame(frame);
      ro.disconnect();
    };
  }, [isMobile, viewportWidth, viewportHeight]);

  return {
    isMobile,
    containerRef,
    baseSize, // width on desktop, height on mobile
    menuSize, // width on desktop, height on mobile
    animReady,
  };
}
